import React, { useState } from 'react';
import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { Alert, Box, Button, Paper, Stack, Typography } from '@mui/material';
import { auth } from '../firebase';
import { COLORS } from '../pos/theme';

const googleProvider = new GoogleAuthProvider();

const LoginPage = () => {
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleGoogle = async () => {
    setBusy(true);
    setError('');
    try {
      await signInWithPopup(auth, googleProvider);
    } catch (err: any) {
      setError(err?.message || 'sign-in failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: COLORS.pageBg,
        px: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 4,
          maxWidth: 420,
          width: '100%',
          border: `1px solid ${COLORS.border}`,
          borderRadius: 2,
        }}
      >
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Typography
            variant="h5"
            sx={{ fontWeight: 700, color: COLORS.text, letterSpacing: '0.02em' }}
          >
            Atlantic Grow Shop
          </Typography>
          <Typography
            variant="overline"
            sx={{ color: COLORS.textMuted, letterSpacing: '0.25em', fontWeight: 600 }}
          >
            Register
          </Typography>
        </Box>

        <Stack spacing={2}>
          {/* Same Google sign-in as web-admin — identical accounts. */}
          <Button
            variant="contained"
            onClick={handleGoogle}
            disabled={busy}
            fullWidth
            size="large"
            sx={{ textTransform: 'none', py: 1.5, fontSize: '1rem' }}
          >
            Continue with Google
          </Button>

          {error && <Alert severity="error">{error}</Alert>}
        </Stack>
      </Paper>
    </Box>
  );
};

export default LoginPage;
